const MEASUREMENT_ID = (process.env.REACT_APP_GA_MEASUREMENT_ID || '').trim();

const CONSENT_KEY = 'analytics_consent';
const BLOCKED_KEYS = new Set([
  'email', 'phone', 'address', 'account', 'card_name',
  'recipient_name', 'recipient_phone', 'recipient_address', 'contact_info',
]);

let initialized = false;

export const isAnalyticsConfigured = () => /^G-[A-Z0-9]+$/i.test(MEASUREMENT_ID);
export const getAnalyticsConsent = () => localStorage.getItem(CONSENT_KEY);

const sanitizeParams = (params = {}) => Object.fromEntries(
  Object.entries(params)
    .filter(([key, value]) => !BLOCKED_KEYS.has(key.toLowerCase()) && value !== undefined && value !== null && value !== '')
    .map(([key, value]) => [key, typeof value === 'string' ? value.slice(0, 100) : value])
);

const ensureDataLayer = () => {
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function gtag() { window.dataLayer.push(arguments); };
};

const loadAnalytics = () => {
  if (!isAnalyticsConfigured() || getAnalyticsConsent() !== 'granted') return false;
  ensureDataLayer();
  if (!initialized) {
    initialized = true;
    window.gtag('consent', 'default', {
      analytics_storage: 'granted',
      ad_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied',
    });
    window.gtag('js', new Date());
    window.gtag('config', MEASUREMENT_ID, {
      send_page_view: false,
      allow_google_signals: false,
      allow_ad_personalization_signals: false,
    });
    if (!document.querySelector('script[data-site-analytics]')) {
      const script = document.createElement('script');
      script.async = true;
      script.dataset.siteAnalytics = 'true';
      script.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(MEASUREMENT_ID);
      document.head.appendChild(script);
    }
  }
  return true;
};

export const setAnalyticsConsent = (granted) => {
  localStorage.setItem(CONSENT_KEY, granted ? 'granted' : 'denied');
  if (granted) loadAnalytics();
};

export const analyticsEvent = (name, params = {}) => {
  if (!loadAnalytics()) return;
  window.gtag('event', name, sanitizeParams(params));
};

const safePath = (pathname) => {
  if (/^\/v\/[^/]+/.test(pathname)) return '/v/shared';
  if (/^\/account\/orders\/[^/]+/.test(pathname)) return '/account/orders/:id';
  return pathname;
};
const safeSearch = (search) => {
  const params = new URLSearchParams(search);
  const sensitive = /token|email|phone|address|account|code|invite|key|secret/i;
  [...params.keys()].forEach((key) => {
    if (sensitive.test(key)) params.delete(key);
  });
  const result = params.toString();
  return result ? '?' + result : '';
};


export const trackPageView = (pathname, search = '') => {
  if (pathname.startsWith('/admin') || !loadAnalytics()) return;
  window.gtag('event', 'page_view', {
    page_path: safePath(pathname) + safeSearch(search),
    page_location: window.location.origin + safePath(pathname) + safeSearch(search),
    page_title: document.title,
  });
};

export const gaItem = (item, index) => ({
  item_id: String(item.id ?? item.productId ?? item.variantId ?? ''),
  item_name: item.name ?? item.productName ?? 'item',
  item_category: item.category ?? item.type ?? undefined,
  item_variant: item.variantName ?? item.variant ?? undefined,
  price: Number(item.price ?? 0),
  quantity: Number(item.qty ?? item.quantity ?? 1),
  index,
});

export const trackSearch = (term, section) => {
  if (term) analyticsEvent('search', { search_term: term, section });
};

export const trackFilter = (name, value, section) => {
  analyticsEvent('filter_content', { filter_name: name, filter_value: String(value), section });
};
